import * as types from './actionTypes';
import handleErrors from './handleErrors';
import getAPIPath from '../../js/modules/api-location';
import { addNotification } from './notificationActions';

export function getLicenceInfoSuccess(data) {
  return { type: types.GET_LICENCE_INFO_SUCCESS, data };
}

export function getAllocatedLicencesSuccess(res) {
  return { type: types.GET_ALLOCATED_LICENCES_SUCCESS, res };
}

export function allocateLicenceSuccess(data) {
  return { type: types.ALLOCATE_LICENCE_SUCCESS, data };
}

export function removeLicenceSuccess(licenceId) {
  return { type: types.REMOVE_LICENCE_SUCCESS, licenceId };
}

export function editLicenceSuccess(licenceId, newLicenceType) {
  return { type: types.EDIT_LICENCE_SUCCESS, licenceId, newLicenceType };
}

export function getLicenceInfo() {
  return function(dispatch) {
    return fetch(`${getAPIPath}queryapi/licence-info`, {
      method: 'GET',
      credentials: 'include',
      headers: {
        Accept: 'application/json',
      },
    })
    .then(handleErrors)
    .then((response) => {
      response.json().then((res) => {
        dispatch(getLicenceInfoSuccess(res.data));
      });
    })
    .catch(response => response.json().then((res) => {
      throw res;
    }));
  };
}

export function getAllocatedLicences(pageNumber, sortBy) {
  let optionalParams = '';
  if (pageNumber) {
    optionalParams = `&page-number=${pageNumber}`;
  }
  if (sortBy) {
    optionalParams += `&sort-by=${sortBy}`;
  }

  return function(dispatch) {
    return fetch(`${getAPIPath}queryapi/allocated-licences?${optionalParams}`, {
      method: 'GET',
      credentials: 'include',
      headers: {
        Accept: 'application/json',
      },
    })
    .then(handleErrors)
    .then((response) => {
      response.json().then((res) => {
        dispatch(getAllocatedLicencesSuccess(res));
      });
    })
    .catch(response => response.json().then((res) => {
      throw res;
    }));
  };
}

export function allocateLicence(emailAddress, licenceType) {
  const item = {};
  item['email-address'] = emailAddress.toLowerCase();
  item['licence-type'] = licenceType;

  return function(dispatch) {
    return fetch(`${getAPIPath}commandapi/licence`, {
      method: 'POST',
      body: JSON.stringify(item),
      credentials: 'include',
      headers: {
        Accept: 'application/json',
      },
    })
    .then(handleErrors)
    .then((response) => {
      response.json().then((res) => {
        dispatch(allocateLicenceSuccess(res.data));
        dispatch(getLicenceInfo());
      });
    })
    .catch(response => response.json().then((res) => {
      dispatch(addNotification({
        message: res.message,
        level: 'error',
        autoDismiss: 0,
      }));
      throw res;
    }));
  };
}

export function removeLicence(userId, licenceId) {
  return function(dispatch) {
    return fetch(`${getAPIPath}commandapi/licence?licencee-id=${userId}`, {
      method: 'DELETE',
      credentials: 'include',
      headers: {
        Accept: 'application/json',
      },
    })
    .then(handleErrors)
    .then((response) => {
      response.json().then(() => {
        dispatch(removeLicenceSuccess(licenceId));
        dispatch(getLicenceInfo());
      });
    })
    .catch(response => response.json().then((res) => {
      dispatch(addNotification({
        message: res.message,
        level: 'error',
        autoDismiss: 0,
      }));
      throw res;
    }));
  };
}

export function editLicence(licenceId, newLicenceType) {
  const item = {};
  item['licence-id'] = licenceId;
  item['new-licence-type'] = newLicenceType;

  return function(dispatch) {
    return fetch(`${getAPIPath}commandapi/licence`, {
      method: 'PUT',
      body: JSON.stringify(item),
      credentials: 'include',
      headers: {
        Accept: 'application/json',
      },
    })
    .then(handleErrors)
    .then((response) => {
      response.json().then((res) => {
        dispatch(editLicenceSuccess(licenceId, newLicenceType));
        dispatch(getLicenceInfo());
        dispatch(addNotification({
          message: res.message,
          level: 'success',
          autoDismiss: 3,
          dismissible: 'click',
        }));
      });
    })
    .catch(response => response.json().then((res) => {
      dispatch(addNotification({
        message: res.message,
        level: 'error',
        autoDismiss: 0,
      }));
      throw res;
    }));
  };
}



// WEBPACK FOOTER //
// ./library/app/actions/licenceActions.js